import { withStyles } from '@material-ui/core';

import { Field } from 'formik';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { ToggleSelect } from 'modules/intake/form';
import { YES_NO_OPTIONS } from 'utilities/common';
import Hint from 'modules/common/hint.component';
import Log from 'utilities/log';

import styles from 'modules/intake/styles';

class PropertyFloodInsuranceForm extends Component {
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props.floodInsurance, nextProps.floodInsurance);
  }

  render() {
    Log.trace('RENDER', 'PropertyFloodInsuranceForm');
    const {
      floodInsurance,
      handleChange,
      handleBlur,
      rootPath,
    } = this.props;

    return (
      <>
        <div className="row">
          <Field
            component={ToggleSelect}
            name={`${rootPath}.isFloodInsuranceRequired`}
            value={floodInsurance.isFloodInsuranceRequired}
            onChange={handleChange}
            onBlur={handleBlur}
            options={YES_NO_OPTIONS}
            label="Flood Insurance Required"
          />
        </div>
        {floodInsurance.isFloodInsuranceRequired &&
          <Hint>Please request a copy of flood certificate</Hint>
        }
      </>
    );
  }
}

PropertyFloodInsuranceForm.propTypes = {
  floodInsurance: PropTypes.object.isRequired,
  rootPath: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  metadata: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PropertyFloodInsuranceForm);
